import { render, staticRenderFns } from "./VLongAnswer.vue?vue&type=template&id=fda17824&scoped=true"
import script from "./VLongAnswer.vue?vue&type=script&lang=js"
export * from "./VLongAnswer.vue?vue&type=script&lang=js"
import style0 from "./VLongAnswer.vue?vue&type=style&index=0&id=fda17824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda17824",
  null
  
)

export default component.exports